import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { getConfig, initWithConfig } from '../core';
import db from '../database';
import FirebaseAuthContext, {
  FIREBASE_AUTH_DEFAULT_CONFIG,
} from './firebase-auth-context';

// NOTE la table `allowedContributors` est commune à tous les projets
// elle composée de { [user.id]:  user.email }
const ADMINS_TABLE_NAME = 'allowedContributors';

const checkIfUserIsAdminRole = user => {
  const userisvalid = user && user.uid;
  if (!userisvalid) {
    return Promise.resolve(false);
  }
  const { email, uid } = user;
  return db.read(uid, ADMINS_TABLE_NAME).then(payload => {
    const isadmin = payload && payload === email;
    return isadmin;
  });
};

const FirebaseAuthProvider = ({ children, config, firebase, persistence }) => {
  const changeListener = useRef(null);
  const app = initWithConfig(firebase, config);

  // firebase
  //   .auth()
  //   .getRedirectResult()
  //   .then(result => {
  // console.log('result', result);
  // });

  const [state, setState] = useState({
    ...FIREBASE_AUTH_DEFAULT_CONFIG,
    firebase: app,
  });

  const onAuthChange = useCallback(
    user => {
      const next = {
        firebase: app,
        isAdmin: false,
        isAnonymous: user?.isAnonymous || true,
        isReady: true,
        isSignedIn: !!user,
        providerId: user?.providerData[0]?.providerId || null,
        token: null,
        user,
      };

      checkIfUserIsAdminRole(user).then(isAdmin => {
        setState({ ...next, isAdmin });
      });
    },
    [app]
  );

  useEffect(() => {
    if (!changeListener.current) {
      app.auth().setPersistence(persistence);
      changeListener.current = app.auth().onAuthStateChanged(onAuthChange);
    }
    return () => {
      const removeChangedListener = changeListener.current;
      removeChangedListener();
    };
  }, [persistence, app, onAuthChange]);

  return (
    <FirebaseAuthContext.Provider value={state}>
      {children}
    </FirebaseAuthContext.Provider>
  );
};

FirebaseAuthProvider.defaultProps = {
  config: getConfig(),
  persistence: 'local',
};

FirebaseAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  config: PropTypes.shape({
    apiKey: PropTypes.string.isRequired,
    appId: PropTypes.string,
    authDomain: PropTypes.string.isRequired,
    databaseURL: PropTypes.string.isRequired,
    messagingSenderId: PropTypes.string,
    projectId: PropTypes.string.isRequired,
    storageBucket: PropTypes.string.isRequired,
  }),
  firebase: PropTypes.shape().isRequired,
  persistence: PropTypes.oneOf([
    'local', // firebase.auth.Auth.Persistence.LOCAL,
    'sesssion', // firebase.auth.Auth.Persistence.SESSION,
    'none', // firebase.auth.Auth.Persistence.NONE,
  ]),
};

FirebaseAuthProvider.displayName = 'FirebaseAuthProvider';

export default FirebaseAuthProvider;
